export default {
    namespaced: true,
    state: {
        dataGroups: [],
        loading: false,
        error: null,
        total: 0,
        accountList: [],
    },
    mutations: {
        SET_DATA_GROUPS(state, dataGroups) {
            state.dataGroups = dataGroups;
        },
        SET_ACCOUNT_LIST(state, accountList) {
            state.accountList = accountList;
        },
        SET_LOADING(state, loading) {
            state.loading = loading;
        },
        SET_ERROR(state, error) {
            state.error = error;
        },
        SET_TOTAL(state, total) {
            state.total = total;
        },
        CLEAR_DATA(state) {
            state.dataGroups = [];
            state.currentGroup = null;
        },
    },
    actions: {
        async fetchAccountList({ commit }) {
            const response = await this._vm.$http.get(
                "/launch/account/listALL"
            );
            commit("SET_ACCOUNT_LIST", response.data.body.data || []);
        },
        async updateDataGroupCreator({ commit, dispatch }, dataGroup) {
            try {
                // 如果creator是数组，转换为逗号分隔的字符串
                let creatorValue = dataGroup.creator;
                if (Array.isArray(creatorValue)) {
                    creatorValue = creatorValue.join(",");
                }

                const response = await this._vm.$http.post(
                    `/launch/buy/data/group/update/creator`,
                    {
                        webSiteUrl: dataGroup.webSiteUrl,
                        creator: creatorValue,
                    }
                );

                const { data } = response;
                if (data.header.code === 0) {
                    await dispatch("fetchDataGroups", {
                        pageNum: 1,
                        pageSize: 10,
                    });
                    return true;
                } else {
                    throw new Error(data.header.msg || "修改失败");
                }
            } catch (error) {
                throw error.response?.data?.msg || error.message || "修改失败";
            }
        },
        async fetchDataGroups({ commit }, { pageNum, pageSize, sid }) {
            commit("SET_LOADING", true);
            try {
                let url = `/launch/data/group/list?pageNum=${pageNum}&pageSize=${pageSize}`;
                if (sid) {
                    url += `&sid=${encodeURIComponent(sid)}`;
                }
                const response = await this._vm.$http.post(url);
                const dataGroups = response.data.body.data || [];
                const total = response.data.body.total || 0;
                commit("SET_DATA_GROUPS", dataGroups);
                commit("SET_TOTAL", total);
                return { data: dataGroups, total };
            } catch (error) {
                commit("SET_ERROR", error.message);
                throw (
                    error.response?.data?.msg || error.message || "获取数据失败"
                );
            } finally {
                commit("SET_LOADING", false);
            }
        },

        async createDataGroup({ commit, dispatch }, dataGroup) {
            try {
                const response = await this._vm.$http.post(
                    `/launch/data/group/save?sid=${encodeURIComponent(
                        dataGroup.sid
                    )}&platformType=${encodeURIComponent(
                        dataGroup.platformType.join(",")
                    )}`
                );

                const { data } = response;
                if (data.header.code === 0) {
                    await dispatch("fetchDataGroups", {
                        pageNum: 1,
                        pageSize: 10,
                    });
                    return true;
                } else {
                    throw new Error(data.header.msg || "创建数据组失败");
                }
            } catch (error) {
                throw (
                    error.response?.data?.msg ||
                    error.message ||
                    "创建数据组失败"
                );
            }
        },

        async updateDataGroup({ commit, dispatch }, dataGroup) {
            try {
                const response = await this._vm.$http.post(
                    `/launch/data/group/update?sid=${encodeURIComponent(
                        dataGroup.sid
                    )}&platformType=${encodeURIComponent(
                        dataGroup.platformType.join(",")
                    )}`
                );

                const { data } = response;
                if (data.header.code === 0) {
                    await dispatch("fetchDataGroups", {
                        pageNum: 1,
                        pageSize: 10,
                    });
                    return true;
                } else {
                    throw new Error(data.header.msg || "更新数据组失败");
                }
            } catch (error) {
                throw (
                    error.response?.data?.msg ||
                    error.message ||
                    "更新数据组失败"
                );
            }
        },

        async deleteDataGroup({ commit, dispatch }, sid) {
            try {
                const response = await this._vm.$http.post(
                    `/launch/data/group/remove?sid=${encodeURIComponent(sid)}`
                );

                const { data } = response;
                if (data.header.code === 0) {
                    await dispatch("fetchDataGroups", {
                        pageNum: 1,
                        pageSize: 10,
                    });
                    return true;
                } else {
                    throw new Error(data.header.msg || "删除数据组失败");
                }
            } catch (error) {
                throw (
                    error.response?.data?.msg ||
                    error.message ||
                    "删除数据组失败"
                );
            }
        },

        // 分cid域名数据权限相关方法
        async fetchCidGroups({ commit }, { pageNum, pageSize, webSiteUrl }) {
            commit("SET_LOADING", true);
            try {
                const response = await this._vm.$http.get(
                    "/launch/buy/data/group/cid/list",
                    {
                        params: {
                            pageNum,
                            pageSize,
                            webSiteUrl,
                        },
                    }
                );
                const cidGroups = response.data.body.data || [];
                const total = response.data.body.total || 0;
                return { data: cidGroups, total };
            } catch (error) {
                commit("SET_ERROR", error.message);
                throw (
                    error.response?.data?.msg ||
                    error.message ||
                    "获取分cid域名数据失败"
                );
            } finally {
                commit("SET_LOADING", false);
            }
        },

        async createCidGroup({ commit }, webSiteUrl) {
            try {
                const response = await this._vm.$http.post(
                    "/launch/buy/data/group/cid/save",
                    {
                        webSiteUrl,
                    }
                );

                const { data } = response;
                if (data.header.code === 0) {
                    return true;
                } else {
                    throw new Error(
                        data.header.msg || "创建分cid域名数据权限失败"
                    );
                }
            } catch (error) {
                throw (
                    error.response?.data?.msg ||
                    error.message ||
                    "创建分cid域名数据权限失败"
                );
            }
        },

        async deleteCidGroup({ commit }, webSiteUrl) {
            try {
                const response = await this._vm.$http.post(
                    "/launch/buy/data/group/cid/remove",
                    {},
                    {
                        params: {
                            webSiteUrl,
                        },
                    }
                );

                const { data } = response;
                if (data.header.code === 0) {
                    return true;
                } else {
                    throw new Error(
                        data.header.msg || "删除分cid域名数据权限失败"
                    );
                }
            } catch (error) {
                throw (
                    error.response?.data?.msg ||
                    error.message ||
                    "删除分cid域名数据权限失败"
                );
            }
        },
        async setRemarkWebSiteUrl(
            { commit },
            { webSiteUrl, categoryName, remarks }
        ) {
            const temp = {};
            temp.webSiteUrl = webSiteUrl;
            temp.categoryName = categoryName;
            temp.remarks = remarks;

            try {
                const response = await this._vm.$http.post(
                    "/launch/buy/data/group/updateCategory",
                    temp
                );

                const { data } = response;
                if (data.header.code === 0) {
                    return true;
                } else {
                    throw new Error(
                        data.header.msg || "批量更新分类和备注失败"
                    );
                }
            } catch (error) {
                throw (
                    error.response?.data?.msg ||
                    error.message ||
                    "批量更新分类和备注失败"
                );
            }
        },

        async getCategoryNameList({ commit }) {
            try {
                const response = await this._vm.$http.get(
                    "/launch/buy/data/getWebSiteCategoryNameList"
                );

                const { data } = response;
                if (data.header.code === 0) {
                    return data.body.data || [];
                } else {
                    throw new Error(data.header.msg || "获取分类列表失败");
                }
            } catch (error) {
                throw (
                    error.response?.data?.msg ||
                    error.message ||
                    "获取分类列表失败"
                );
            }
        },
    },
};
